import { render, staticRenderFns } from "./AddFreeSkillsWithRecommendations.vue?vue&type=template&id=532c9b19&scoped=true&"
import script from "./AddFreeSkillsWithRecommendations.vue?vue&type=script&lang=js&"
export * from "./AddFreeSkillsWithRecommendations.vue?vue&type=script&lang=js&"
import style0 from "./AddFreeSkillsWithRecommendations.vue?vue&type=style&index=0&id=532c9b19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532c9b19",
  null
  
)

export default component.exports